import React from "react";

const Download = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 19">
    <defs />
    <path d="M9 14a1 1 0 002 0l5-5a1 1 0 00-2-2l-3 4V1a1 1 0 00-2 0v10L6 7a1 1 0 00-2 2z" data-name="Path 132903" />
    <path
      d="M3 19h14a3 3 0 003-3v-4a1 1 0 10-2 0v4a1 1 0 01-1 1H3a1 1 0 01-1-1v-4a1 1 0 10-2 0v4a3 3 0 003 3z"
      data-name="Path 132904"
    />
  </svg>
);

export default Download;
